import { useCallback, useState } from "react";
import { createConfirmGate } from "../lib/util/confirmGate.js";

/**
 * The confirm surface for #5636. A branch inherits its ROOT's engine (the picker is only
 * the fallback), so when that engine is a deep lane the picker did not select,
 * `useBranchForecast` asks before dispatching. This hook owns the question's React state
 * (kept out of AppInner — the ratchet counts its useState calls) and hands the branch hook
 * an async `confirmBranchEngine` it awaits like `guardForTos`. `BranchEngineConfirmModal`
 * renders `branchEngineConfirm` and answers through `settleBranchEngineConfirm`.
 */
export function useBranchEngineConfirm() {
  const [branchEngineConfirm, setBranchEngineConfirm] = useState(null);
  // One gate per mount (lazy initializer); it mirrors its open question into state, and
  // the setter is stable, so the gate never goes stale.
  const [gate] = useState(() => createConfirmGate(setBranchEngineConfirm));
  const confirmBranchEngine = useCallback((request) => gate.ask(request), [gate]);
  const settleBranchEngineConfirm = useCallback((answer) => gate.settle(answer), [gate]);
  return { branchEngineConfirm, confirmBranchEngine, settleBranchEngineConfirm };
}
